// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__31-FB","browse":"Navbar_browse__ATsB_"};